import React, {Fragment, ReactNode} from 'react';
import {History} from 'history';
import clsx from 'clsx';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import Header from './header';
import Sidebar from './sidebar';
import BaseContentLoader from "../elements/baseContentLoader";
import {getUserInfo} from "../vendors/actions/user";
import {getCaseTypes, getStates} from "../vendors/actions/static";
import * as Modals from "./modals";
import MobileNavBar from "./mobileNavbar";


interface OwnProps {
    getUserInfo?: any,
    getStates?: any,
    getCaseTypes?: any,
    UserLoginForm?: any
    userLoginFormChange?: any,
    children: ReactNode,
    history: History,
    titleHeading?: any
}

interface MainState {
    loaded: boolean
}

interface ConnectStateProps {
    User: any,
    States: any,
    Layout: any,
    CaseTypes: any
}

interface ConnectDispatchProps {
    getUserInfo?: (data: any) => void;
}


type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;


const modals = Object.keys(Modals).map((val: string, key: number) => {
    // @ts-ignore
    const Component = Modals[val];
    return <Component key={key}/>
});


class BaseLayout extends React.PureComponent<HeaderProps, MainState> {
    state = {
        loaded: false
    };

    componentDidMount() {
        const {User, States, CaseTypes} = this.props;
        if (!Object.keys(User).length) {
            this.props.getUserInfo();
        }
        if (!Object.keys(States).length) {
            this.props.getStates();
        }
        if (!Object.keys(CaseTypes).length) {
            this.props.getCaseTypes();
        }
    }

    static getDerivedStateFromProps(props: any) {
        const {User, Error, history, States, CaseTypes} = props;
        if (Object.keys(User).length && States.length && CaseTypes.length) {
            return {
                loaded: true
            }
        }

        if (Error.User) {
            history.push('/login');
            return {
                loading: false
            };
        }
        return null
    }

    render() {
        const {children, history} = this.props;
        const {
            sidebarToggle,
            sidebarFixed,
            footerFixed,
            contentBackground
        } = this.props.Layout;
        const {loaded} = this.state;

        return (<Fragment>
            <div className={clsx('app-wrapper', contentBackground)}>
                {!loaded ? <BaseContentLoader/> : <Fragment>
                    <Header history={history}/>
                    <div className={clsx('app-main', {
                            'app-main-sidebar-static': !sidebarFixed
                        })}>
                        <Sidebar history={history}/>
                        <div
                            className={clsx('app-content', {
                                'app-content-sidebar-collapsed': sidebarToggle,
                                'app-content-sidebar-fixed': sidebarFixed,
                                'app-content-footer-fixed': footerFixed
                            })}>
                            <div className="app-content--inner consumer">
                                {/* <Breadcrumbs
                                    separator={<NavigateNextIcon fontSize="small"/>}
                                    className="mb-4"
                                    maxItems={2}
                                    aria-label="breadcrumb">
                                    <Link color="inherit" to="#" onClick={(e: any) => e.preventDefault()}>
                                        Home
                                    </Link>
                                    <Link color="inherit" to="#" onClick={(e: any) => e.preventDefault()}>
                                        Dashboards
                                    </Link>
                                    <Link color="inherit" to="#" onClick={(e: any) => e.preventDefault()}>
                                        Examples
                                    </Link>
                                    <Link color="inherit" to="#" onClick={(e: any) => e.preventDefault()}>
                                        Pages
                                    </Link>
                                    <Typography color="textPrimary">{this.props.titleHeading}</Typography>
                                </Breadcrumbs>*/}
                                <div className="app-content--inner__wrapper">{children}</div>
                            </div>
                        </div>
                    </div>
                    {modals}
                </Fragment>}
                <MobileNavBar history={history}/>
            </div>
        </Fragment>)
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Layout, Error, CaseTypes, States} = state;
    return {
        User,
        Layout,
        Error,
        CaseTypes,
        States
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        getUserInfo: () => dispatch(getUserInfo()),
        getStates: () => dispatch(getStates()),
        getCaseTypes: () => dispatch(getCaseTypes()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BaseLayout);
